
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","height":"34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17 .448C7.858.448.448 7.858.448 17S7.858 33.552 17 33.552 33.552 26.142 33.552 17 26.142.448 17 .448zm7.734 12.586c.008.171.011.344.011.516 0 5.272-4.013 11.353-11.353 11.353-2.253 0-4.35-.66-6.116-1.793a8.006 8.006 0 005.907-1.653 3.994 3.994 0 01-3.727-2.771 4.002 4.002 0 001.801-.069 3.991 3.991 0 01-3.2-3.912v-.05c.538.298 1.153.479 1.808.499a3.989 3.989 0 01-1.236-5.327 11.328 11.328 0 008.225 4.169 3.99 3.99 0 016.8-3.639 7.988 7.988 0 002.532-.968 4.004 4.004 0 01-1.754 2.207 7.971 7.971 0 002.291-.628 8.114 8.114 0 01-1.99 2.065v.001z","fill":"#fff"}})])
          )
        }
      }
    